<template>
    <div class="d-flex flex-nowrap">
        <div @click="onSelect" class="flex-grow-1">
            <div @mouseenter="onMouseEnter"
                 @mouseleave="onMouseLeave"
                 class="d-flex connection-item"
                 :class="{
                     'connection-highlighted': isHovered && !disabled,
                     'connection-selected': isSelected,
                     'clickable': selectable
                 }">
                <div class="flex-grow-1 px-1">
                    {{ connection.name }}
                </div>
                <div class="px-1">
                    <span v-if="!disabled && isHovered"
                          v-tooltip="'Delete connection'"
                          @click="onDelete"
                          class="text-danger clickable">
                        <i class="fal fa-trash-alt"></i>
                    </span>
                </div>
            </div>
        </div>
        <span v-if="!disabled"
              v-tooltip="statusModel.label ? `Last status: ${statusModel.label}` : 'Connect'"
              @click="onEdit"
              class="plug-btn text-center ml-1"
              :class="{disabled}"
              :style="{ 'background-color': statusModel.color, 'color': statusModel.color ? 'white' : '#6C757D' }">
            <i class="fa fa-plug"></i>
        </span>
    </div>
</template>

<script>
import {getConnectionStatus} from '@/types/apps/connections'

export default {
    name: 'AppAuthConnectionsListItem',
    props: {
        connection: {
            type: Object,
            required: true
        },
        isSelected: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isHovered: false
        }
    },
    computed: {
        statusModel() {
            return getConnectionStatus(this.connection.status)
        }
    },
    methods: {
        onSelect() {
            if (this.selectable) {
                this.$emit('select', this.connection)
            }
        },

        onEdit() {
            this.$emit('edit', this.connection)
        },

        onDelete() {
            this.$emit('delete', this.connection)
        },

        onMouseEnter() {
            this.isHovered = true
        },

        onMouseLeave() {
            this.isHovered = false
        }
    }
}
</script>

<style lang="scss" scoped>
.connection-item, .plug-btn {
    padding: 8px;
    border: 1px solid $color-grey-light;
    border-radius: 5px;
    margin-top: 4px;
}

.connection-highlighted {
    background: $color-purple-soft;
}

.plug-btn {
    flex: 0 0 40px;

    &:hover {
        background: $color-purple-soft;
        cursor: pointer;
    }
}

.connection-selected {
    border-left: 6px solid $color-purple-light;
}
</style>
